import { Typography } from "@/react/components/shared/uikit/Typography";
import type { BadgeProperty } from "@/react/types/PaywallCustomization";
import { Icon } from "./Icon";

export const Badge = ({
  background_color,
  icon,
  label,
  text_color,
  visible,
}: BadgeProperty) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className="flex flex-row flex-wrap items-center gap-x-2 rounded-full px-3 py-1"
      style={{ backgroundColor: background_color }}
      data-testid="paywall-badge"
    >
      <Icon icon={icon} data-testid="paywall-badge-icon" />
      <Typography.LabelXs weight="medium">
        <span style={{ color: text_color }} data-testid="paywall-badge-label">
          {label}
        </span>
      </Typography.LabelXs>
    </div>
  );
};
